// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2-7E-","title":"Info_title__tCKNl","selects":"Info_selects__1a1lN","requiredAsterisk":"Info_requiredAsterisk__1w-7n"};